import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 0;
  height: 100%;
`;

export const BackBtn = styled.button`
  appearance: none;
  background-color: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  color: #181818;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  justify-content: space-between;
  border: none;
  background: none;
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Download = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const DownloadOptions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3px;

  & div {
    cursor: pointer;
  }
`;

export const Title = styled.h1`
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 40px;
  min-height: 0;
  flex: 1 1 auto;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;

export const Submenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 0 0 140px;

  & a {
    color: #181818;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    text-decoration: none;

    &:hover {
      background-color: #ebf4ff;
    }
  }
`;

export const EntityContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
`;

export const ContentScroller = styled.div.attrs({
  "data-testid": "content-scroll",
} as Record<string, string>)`
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  padding-right: 16px;
`;

export const Entity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const EntityTitle = styled.h2`
  color: #181818;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
`;

export const RowedData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 24px;
`;

export const Row = styled.div`
  border-bottom: #e7e7e7 1px solid;
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: 100%;
  padding-bottom: 12px;
`;

export const Description = styled.p`
  color: #181818;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  flex: 0 0 156px;
`;

export const Value = styled.p`
  color: #181818;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const DividedRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
`;
